module.exports = __webpack_public_path__ + "images/70d38f4.png";